"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchRequest = void 0;
const errors_1 = require("./errors");
async function fetchRequest(fetch, method, url, query, body, config) {
    // Do we have some data?
    if (query) {
        // Seems to detect the node version
        // eslint-disable-next-line node/no-unsupported-features/node-builtins
        const searchParams = new URLSearchParams();
        for (const [key, value] of Object.entries(query)) {
            // eslint-disable-next-line security/detect-object-injection
            if (key == null || value == null) {
                continue;
            }
            if (Array.isArray(value)) {
                for (const index in value) {
                    // eslint-disable-next-line security/detect-object-injection
                    searchParams.append(key, `${value[index]}`);
                }
            }
            else {
                searchParams.append(key, `${value}`);
            }
        }
        const qs = searchParams.toString();
        if (qs !== "") {
            url += "?" + qs;
        }
    }
    const headers = {
        // TODO this will only work for Record<String> not [string,string] headers in HeadersInit
        ...config?.headers,
        Accept: "application/json",
    };
    const init = {
        ...config,
        method: method,
        headers,
    };
    if (method !== "GET" && body != null) {
        headers["Content-Type"] = "application/json";
        // As our Content-Type is application/json we need valid a JSON body
        init.body = JSON.stringify(body ?? {});
    }
    return fetch(url, init).then((res) => handleFetchResponse(res));
}
exports.fetchRequest = fetchRequest;
async function handleFetchResponse(response) {
    if (response.ok) {
        try {
            return response.json();
        }
        catch (err) {
            const contentType = response.headers.get("content-type") ?? "unknown";
            throw new errors_1.NetworkClientFetchError(response.status, response.url, `Response is not JSON: ${contentType}`, null);
        }
    }
    else {
        // Rethrow something which looks like the original error
        const url = response?.url ?? "unknown";
        let data;
        try {
            data = (await response.json());
        }
        catch (err) {
            // If the body can't be parsed, return it as a string
            try {
                data = (await response.text());
            }
            catch {
                // Ignore
            }
        }
        const statusCode = data?.statusCode ?? response.status ?? 500;
        const message = `Unknown error with client service call to url=${url}: ${data?.message ?? response.statusText ?? "NA"}`;
        throw new errors_1.NetworkClientFetchError(statusCode, url, message, {
            original: data,
        });
    }
}
